export default "__VITE_ASSET__Bgn$QAjA__"